import rozcestnikZapsat from "../../content/rozcestnik/rozcestnikZapsat";
import { renderLoginComponent } from "../../components/Login";
import { initRozcestnikZapisy } from "./rozcestnikZapisyService";
import { initRozcestnik, callToast } from "./rozcestnikService";
import { destroyElement } from "../../utils/common.mjs";

export function initRozcestnikZapsat(isPublic) {
   
    const tilesDiv = document.getElementById('tiles');
    tilesDiv.innerHTML = "";

    tilesDiv.appendChild(rozcestnikZapsat());
    tilesDiv.style.display = "block";

    const divFormio = document.getElementById('divFormio');
    divFormio.style.display = "none";
    destroyElement('back-button-services');

    const home = document.getElementById('rozcestnikRoot');
    home.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnik(isPublic);
    });

    const rozcestnikZapisy = document.getElementById('rozcestnikZapisy');
    rozcestnikZapisy.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikZapisy(isPublic);
    });

    const toastPoznamky = document.getElementById('toastPoznamky');
    if (toastPoznamky) toastPoznamky.addEventListener("click", event => {
        event.preventDefault();
        callToast("Poznámky");
    });

    let rozcestnikZapsatS8422 = document.getElementById('rozcestnikZapsatS8422');
    if (isPublic) {
        rozcestnikZapsatS8422.addEventListener("click", event => {
            event.preventDefault();
            renderLoginComponent('S8422');
        });
    
    } else {
        rozcestnikZapsatS8422.addEventListener("click", event => {
            event.preventDefault();
            window.initFormio('S8422', null, null);
        });
    
    }    
}
